import React from 'react';

export const TextsContext = React.createContext({} as {[data:string]:string});